import Hook from './Hook';

class HooksManager {
  constructor() {
    this.events = {};
    this.hooks = {};
    this.enabled = false;
  }

  // methods
  getHookById(id) {
    return this.hooks[id][0];
  }

  // convenience function
  registerNewHook(hookId, event, action) {
    const hook = new Hook(hookId, event, action);
    return this.registerHook(hook);
  }

  // toggle hooks by Id
  toggleHooksById(hookId, enabled) {
    const hooks = this.hooks[hookId];
    hooks.forEach((hook) => { hook.enabled = enabled; });
  }

  // registerHook
  registerHook(hook) {
    // TODO: ensure it is a hook
    if (this.hooks[hook.id] === undefined) {
      this.hooks[hook.id] = [];
    }
    if (this.events[hook.event] === undefined) {
      this.events[hook.event] = [];
    }
    hook.manager = this;
    this.hooks[hook.id].push(hook);
    this.events[hook.event].push(hook);

    // allow chainable
    return this;
  }

  // parseHook
  emit(event, data) {
    if (this.enabled === false) return false;

    const hooks = this.events[event];
    if (hooks === undefined) return false;
    hooks.forEach((hook) => { hook.execute(data); });
    return true;
  }
}

const hooksManager = new HooksManager();
// Object.freeze(hooksManager);
export default hooksManager;
